export default "__VITE_ASSET__867f080d__"